<template>
  <div class="banner-3 row">
    <div class="py-sm-4 py-md-auto col-md-4 col-sm-12">
      <carousel
        :per-page="1"
        :mouse-drag="true"
        :autoplay="true"
        :loop="true"
        autoplayDirection="forward"
        :paginationEnabled="false"
      >
        <slide>
          <img class="d-block w-100" :src="url+'public/images/slider/cuadrados/cuadrada1.gif'" />
        </slide>
        <slide>
          <img class="d-block w-100" :src="url+'public/images/slider/cuadrados/cuadrada2.gif'" />
        </slide>
        <slide>
          <img class="d-block w-100" :src="url+'public/images/slider/cuadrados/cuadrada3.gif'" />
        </slide>
      </carousel>
    </div>
    <div class="py-sm-4 py-md-auto col-md-4 col-sm-12">
      <carousel
        :per-page="1"
        :mouse-drag="true"
        :autoplay="true"
        :loop="true"
        autoplayDirection="forward"
        :paginationEnabled="false"
      >
        <slide>
          <img class="d-block w-100" :src="url+'public/images/slider/cuadrados/cuadrada4.gif'" />
        </slide>
        <slide>
          <img class="d-block w-100" :src="url+'public/images/slider/cuadrados/cuadrada5.gif'" />
        </slide>
      </carousel>
    </div>
    <div class="py-sm-4 py-md-auto col-md-4 col-sm-12">
      <carousel
        :per-page="1"
        :mouse-drag="true"
        :autoplay="true"
        :loop="true"
        autoplayDirection="forward"
        :paginationEnabled="false"
      >
        <slide>
          <img class="d-block w-100" :src="url+'public/images/slider/cuadrados/cuadrada6.gif'" />
        </slide>
        <slide>
          <img class="d-block w-100" :src="url+'public/images/slider/cuadrados/cuadrada7.gif'" />
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import Configs from "@/configs/configs";

export default {
  data(){
    return{
      url: Configs.API.BASE,
    }
  },
  components: {
    Carousel,	
    Slide
  }
}
</script>